<app-share-button ></app-share-button>

<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>
                        परिचय </h2>
                </div>
                <!-- <div class="col-md-2 col2"><button class="btn share"><img src="./assets/share (5).svg"
                            style="width: 30px;" alt=""></button>
                </div> -->
                <div class="col-md-2 col2 "> <a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="1">

                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="2">
                    <h2>पुनर्विक्रेता का परिचय</h2>
                    <label for="" class="mt-2">व्यवसाय की निरंतर बदलती दुनिया में, पुनर्विक्रेता एक महत्वपूर्ण भूमिका निभाते हैं वितरण श्रृंखला में. इस दस्तावेज़ का उद्देश्य पुनर्विक्रेता क्या है इसका विस्तृत अवलोकन प्रदान करना है
                        वह है, वे क्या लाभ प्रदान करते हैं, और वे अपनी स्थिति का अधिकतम लाभ कैसे उठा सकत। लाभप्रदता और वृद्धि, विशेष रूप से PayG क्षेत्र में। </label>
                </div>
                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="3">
                    <h2>पुनर्विक्रेता क्या है?</h2>
                    <label for="" class="mt-3">पुनर्विक्रेता एक व्यवसाय या व्यक्ति है जो उत्पाद खरीदता है या
                        किसी निर्माता या वितरक की सेवाएँ जो उन्हें अंतिम ग्राहकों को बेचने का इरादा रखती हैं। पुनर्विक्रेताओं
                        प्रौद्योगिकी, उपभोक्ता वस्तुओं और वित्तीय सेवाओं सहित विभिन्न क्षेत्रों में काम कर सकते हैं।
                        वे अक्सर ग्राहक सहायता, प्रशिक्षण आदि जैसी अतिरिक्त सेवाओं के माध्यम से मूल्य जोड़ते हैं
                        अनुकूलन </label>


                    <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                        id="4">
                        <h2>
                            रिसेलर बनने के लाभ 
                        </h2>


                        <h4 class="mt-4"><b>1. कम ओवरहेड लागत:</b></h4>
                        <label for="">
                            रिसेलर्स न्यूनतम निवेश के साथ काम कर सकते हैं, खासकर जब बिज़नेस को शून्य से शुरू करने की तुलना की जाए। उन्हें निर्माण या उत्पाद विकास में भारी निवेश करने की आवश्यकता नहीं होती।</label>

                        <h4 class="mt-4"><b>2.स्थापित उत्पादों तक पहुंच:</b></h4>
                        <label for="">रिसेलर्स ऐसे उत्पाद और सेवाएं प्रदान कर सकते हैं जो पहले से ही बाजार में परीक्षण किए जा चुके हैं, जिससे नए उत्पाद लॉन्च से जुड़े जोखिम कम हो जाते हैं।</label>

                        <h4 class="mt-4"><b>3.  लचीलापन और स्केलेबिलिटी:</b></h4>
                        <label for="">
                            रिसेलर्स बाजार की मांग के अनुसार अपने इन्वेंट्री और उत्पादों को तेजी से अनुकूलित कर सकते हैं, जिससे वे अपने संचालन को प्रभावी ढंग से बढ़ा सकते हैं।</label>

                        <h4 class="mt-4"><b>4.विविध आय स्रोत:</b></h4>
                        <label for="">कई आपूर्तिकर्ताओं के साथ साझेदारी करके, रिसेलर्स अपने उत्पादों की रेंज और आय के स्रोतों को विविधता प्रदान कर सकते हैं, जिससे किसी एक उत्पाद या आपूर्तिकर्ता पर निर्भरता कम होती है। </label>

                        <h4 class="mt-4"><b>5.नेटवर्किंग के अवसर:</b></h4>
                        <label for="">कई विक्रेताओं और ग्राहकों के साथ काम करने से रिसेलर्स को मूल्यवान संबंध बनाने का अवसर मिलता है, जो उनके बाजार में उपस्थिति और व्यापार संभावनाओं को बढ़ाता है।</label>

                        <h4 class="mt-4"><b> 6. बाजार ज्ञान:</b></h4>
                        <label for="">
                            रिसेलर्स अक्सर उपभोक्ता की प्राथमिकताओं और प्रवृत्तियों को समझते हैं, जो उनके खरीदारी और बिक्री रणनीतियों को सूचित कर सकता है। </label>
                    </div>

                    <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')"
                        id="5">
                        <h2> 
                            रिसेलर्स PayG से कैसे लाभ उठा सकते हैं</h2>
                        <label for="">
                            PayG (Pay-as-you-go) परिदृश्य में, रिसेलर्स को तकनीकी नवाचारों का लाभ उठाने के लिए विशिष्ट अवसर मिलते हैं। यहाँ बताया गया है कि वे कैसे लाभ उठा सकते हैं:: </label>

                        <h4 class="mt-4"><b> 1. बेहतर उत्पाद पेशकश </b></h4>
                        <label for="">PayG के साथ साझेदारी करके, रिसेलर्स उन्नत वित्तीय उत्पादों जैसे भुगतान प्रसंस्करण समाधान, लेंडिंग प्लेटफॉर्म और अकाउंटिंग सॉफ़्टवेयर प्रदान कर सकते हैं। यह नए ग्राहकों को आकर्षित करने और मौजूदा ग्राहकों को बनाए रखने में मदद कर सकता है।. </label>

                        <h4 class="mt-4"><b>2. बेहतर ग्राहक अनुभव </b></h4>
                        <label for="">PayG समाधान का उपयोग करने से संचालन को सुगम बनाया जा सकता है, लेन-देन की गति में सुधार हो सकता है, और ग्राहक समर्थन को बढ़ाया जा सकता है, जिससे अंत-उपयोगकर्ताओं के लिए समग्र अनुभव बेहतर होता है। </label>


                        <h4 class="mt-4"><b>3.प्रतिस्पर्धात्मक लाभ </b></h4>
                        <label for="">जो रिसेलर्स नवाचारी PayG समाधान अपनाते हैं, वे एक प्रतिस्पर्धी बाजार में खुद को अलग कर सकते हैं, और ग्राहकों के साथ मेल खाने वाली विशिष्ट मूल्य प्रस्तावों को प्रदान कर सकते हैं। </label>


                        <h4 class="mt-4"><b> 4.प्रशिक्षण और समर्थन </b></h4>
                        <label for="">PayG अक्सर अपने रिसेलर्स के लिए प्रशिक्षण और समर्थन प्रदान करता है, जिससे उन्हें उत्पादों को प्रभावी तरीके से मार्केटिंग और बिक्री करने के लिए आवश्यक ज्ञान प्राप्त होता है।</label>


                        <h4 class="mt-4"><b> 5. लाभ मार्जिन में वृद्धि</b></h4>
                        <label for="">
                            PayG समाधानों को अपनाकर, रिसेलर्स अपने संचालन को बेहतर बना सकते हैं, लागत को कम कर सकते हैं, और मूल्य-वर्धित सेवाओं के माध्यम से अपने लाभ मार्जिन को बढ़ा सकते हैं।</label>
                    </div>

                    <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'6')" (mouseout)="showpayment(false,'6')"
                        id="6">
                        <h2> रिसेलर्स के लिए सर्वोत्तम प्रथाएँ </h2>


                        <h4 class="mt-4"><b> 1.अपने बाजार को समझें: </b></h4>
                        <label for="">
                            ग्राहकों की आवश्यकताओं और बाजार प्रवृत्तियों की पहचान करने के लिए गहन शोध करें। यह आपके उत्पादों को मांग के अनुसार अनुकूलित करने में मदद करेगा। </label>

                        <h4 class="mt-4"><b>2.   मजबूत रिश्ते बनाएं: </b></h4>
                        <label for="">PayG और ग्राहकों के साथ संबंध विकसित करें। मजबूत साझेदारियाँ बेहतर मूल्य निर्धारण, विशिष्ट उत्पादों, और संयुक्त मार्केटिंग अवसरों की ओर ले जा सकती हैं। </label>


                        <h4 class="mt-4"><b>3. प्रौद्योगिकी का लाभ उठाएं: </b></h4>
                        <label for="">बिक्री रणनीतियों और ग्राहक सहभागिता को बढ़ाने के लिए डिजिटल मार्केटिंग उपकरणों और डेटा विश्लेषण का उपयोग करें।                        </label>


                        <h4 class="mt-4"><b>4. सूचित रहें: </b></h4>
                        <label for="">PayG में नवीनतम विकासों से आगे रहें ताकि आप प्रतिस्पर्धी बने रहें।</label>


                        <h4 class="mt-4"><b>5.
                            ग्राहक समर्थन पर ध्यान दें: </b></h4>
                        <label for="">
                            उत्कृष्ट ग्राहक सेवा प्रदान करना आपके व्यवसाय को अलग कर सकता है और ग्राहकों के बीच दीर्घकालिक वफादारी को बढ़ावा दे सकता है।</label>



                    </div>
                    <p>अधिक जानकारी, संसाधनों या सहायता के लिए, कृपया हमारे समर्थन टीम से संपर्क करने में संकोच न करें। </p>


                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        विषयसूची:
                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span class="videoHover" style="cursor: pointer;"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >
                                    Introduction to
                                    Payment Gateways
                                </span>
                              
                            </div>
                        </div>
                    </a> -->
                </div>
                <div class="col-md-12 ">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')">
                                    रिसेलर का परिचय </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">
                                    रिसेलर क्या है? </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">
                                    रिसेलर बनने के लाभ </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#5">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')"> रिसेलर्स PayG  से कैसे लाभ उठा सकते हैं</span>

                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-md-12 ">
                    <a href="#6">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='6'}"
                                    (click)="color('6')">रिसेलर्स के लिए सर्वोत्तम प्रथाएँ </span>

                            </div>
                        </div>
                    </a>
                </div>

            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/merchant-dashboard']"><button class="btn btn-color"
                        (click)="menues('Creating Profile')"> <img src="./assets/Arrow 3.svg" alt=""> &nbsp;व्यापारी डैशबोर्ड
                        &nbsp;</button></a>
            </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/registration-process']"> <button class="btn btn-color">पंजीकरण प्रक्रिया
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
</div>
